<template>
  <div class="FormPhysicalComponent DataTables">

    <b-row>
        <b-col>
            <p>{{lang.infotext_1}}:</p>
            <div :id="id_main_table"></div>
        </b-col>
        <b-col>
            <p>{{lang.infotext_2}}:</p>
            <div :id="id_properties_table"></div>
        </b-col>
        <b-col>
            <p>{{lang.infotext_3}}:</p>
            <div :id="id_prices_table"></div>
        </b-col>
        <b-col>
            <p>{{lang.infotext_4}}:</p>
            <div :id="id_additional_table"></div>
        </b-col>
    </b-row>
    <br>
 </div>
</template>

<script>
//import { mapState, mapMutations, mapActions, mapGetters, mapTypes } from 'vuex'
//require("datatables.net-buttons-bs4");

export default {
  name: 'FormPhysicalComponent',
  props:{
    lang: Object,
    source: String
  },
  components: {


  },
  data () {
        return {
            name: 'FormPhysicalComponent',
            id_main_table: "id_main_table_" + this._uid,
            id_properties_table: "id_properties_table_" + this._uid,
            id_prices_table: "id_prices_table_" + this._uid,
            id_additional_table: "id_additional_table_" + this._uid,
            mainTable: "",
            propertiesTable: "",
            priceTable: "",
            additionalTable: "",
            main: [
                { param: "DistributorName", name: this.lang.table_main_distributorName, value: "" },
                { param: "DistributorKey", name: this.lang.table_main_distributorKey, value: "" },
                { param: "DistributorPartNumber", name: this.lang.table_main_distributorPartNumber, value: "" },
                { param: "ManufacturerName", name: this.lang.table_main_manufacturerName, value: "" },
                { param: "ManufacturerPN", name: this.lang.table_main_manufacturerPN, value: "" },
                { param: "AvailableQuantityText", name: this.lang.table_main_availableQuantity, value: "" },
                { param: "LeadDaysText", name: this.lang.table_main_leadDays, value: "" },
                { param: "ROHS", name: this.lang.table_main_rohs, value: "" },
                { param: "DtasheetUrl", name: this.lang.table_main_dtasheetUrl, value: "" },
                { param: "Description", name: this.lang.table_main_description, value: "" },
                { param: "ImageUrl", name: this.lang.table_main_imageUrl, value: "" },
                { param: "ProductDetailUrl", name: this.lang.table_main_productDetailUrl, value: "" },
                { param: "LifecycleStatus", name: this.lang.table_main_lifecycleStatus, value: "" }
            ],
            prices: [],

            properties: [],
            currencyTable: ["EUR", "USD", "CHF", "GPB", "PLN"],
            additional: [
                { param: "EOL", name: this.lang.table_label_EOL, value: "" },
                { param: "EOS", name: this.lang.table_label_EOS, value: "" },
                { param: "OverallRisk", name: this.lang.table_label_OverallRisk, value: "" },
                { param: "LifeCycleRiskGrade", name: this.lang.table_label_LifeCycleRiskGrade, value: "" },
                { param: "RohsRisk", name: this.lang.table_label_RohsRisk, value: "" },
                { param: "RoHSVersion", name: this.lang.table_label_RoHSVersion, value: "" },
                { param: "ChinaRoHSStatus", name: this.lang.table_label_ChinaRoHSStatus, value: "" },
                { param: "LifecycleRisk", name: this.lang.table_label_LifecycleRisk, value: "" },
                { param: "PartStatus", name: this.lang.table_label_PartStatus, value: "" },
                { param: "EstimatedYearsToEOL", name: this.lang.table_label_EstimatedYearsToEOL, value: "" },
                { param: "MultiSourcingRisk", name: this.lang.table_label_MultiSourcingRisk, value: "" },
                { param: "Comment", name: this.lang.table_label_Comment, value: "" },
            ],
            optionType: [
                { value: null, text: "" },
                { value: "Low", text: "Low" },
                { value: "Medium", text: "Medium" },
                { value: "High", text: "High" },

            ],
        }
  },
  computed: {
      variant() {
          if (this.$store.getters.s_skinVariant == "dark") {
              return "light";
          } else {
              return "dark";
          }

      }

  },
  created () {


  },
  watch: {

  },
  updated() {


  },
    mounted: function () {

        let vue = this;
        if (this.source == "new") {
            this.main = [
                { param: "DistributorName", name: this.lang.table_main_distributorName, value: "" },
                { param: "DistributorKey", name: this.lang.table_main_distributorKey, value: "" },
                { param: "DistributorPartNumber", name: this.lang.table_main_distributorPartNumber, value: "" },
                //{ param: "informationSource", name: this.lang.table_main_informationSource, value: "" },
                { param: "ManufacturerName", name: this.lang.table_main_manufacturerName, value: "" },
                { param: "ManufacturerPN", name: this.lang.table_main_manufacturerPN, value: "" },
                { param: "AvailableQuantityText", name: this.lang.table_main_availableQuantity, value: "" },
                { param: "LeadDaysText", name: this.lang.table_main_leadDays, value: "" },
                { param: "ROHS", name: this.lang.table_main_rohs, value: "" },
                { param: "DtasheetUrl", name: this.lang.table_main_dtasheetUrl, value: "" },
                { param: "Description", name: this.lang.table_main_description, value: "" },
                { param: "ImageUrl", name: this.lang.table_main_imageUrl, value: "" },
                { param: "ProductDetailUrl", name: this.lang.table_main_productDetailUrl, value: "" },
                { param: "LifecycleStatus", name: this.lang.table_main_lifecycleStatus, value: "" },

                // { param: "EOL", name: this.lang.table_main_EOL, value: "" },
                // { param: "EOS", name: this.lang.table_main_EOS, value: "" },
                // { param: "TempMin", name: this.lang.table_main_TempMin, value: "" },
                // { param: "TempMax", name: this.lang.table_main_TempMax, value: "" },
            ]

            this.buildMainTable();
            this.buildPropertiesTable();
            this.buildPricesTable();
            this.buildAdditionalTable();
        } else if (this.source == "update") {

            const obj = {
                distributorPartId: this.$route.query.distributorPartId
            }

            this.$store.dispatch("getPhysicalDetailsAdditional", obj)
                .then((result) => {

                    console.log(result.data);


                    vue.main = [
                        { param: "DistributorName", name: this.lang.table_main_distributorName, value: result.data.Main[0].DistributorName },
                        { param: "DistributorKey", name: this.lang.table_main_distributorKey, value: result.data.Main[0].DistributorKey },
                        { param: "DistributorPartNumber", name: this.lang.table_main_distributorPartNumber, value: result.data.Main[0].DistributorPartNumber },
                        //{ param: "informationSource", name: this.lang.table_main_informationSource, value: result.data.Main[0].InformationSource },
                        { param: "ManufacturerName", name: this.lang.table_main_manufacturerName, value: result.data.Main[0].ManufacturerName },
                        { param: "ManufacturerPN", name: this.lang.table_main_manufacturerPN, value: result.data.Main[0].ManufacturerPartNumber },
                        { param: "AvailableQuantityText", name: this.lang.table_main_availableQuantity, value: result.data.Main[0].AvailableQuantity },
                        { param: "LeadDaysText", name: this.lang.table_main_leadDays, value: result.data.Main[0].LeadDays },
                        { param: "ROHS", name: this.lang.table_main_rohs, value: result.data.Main[0].IsROHSCompliant },
                        { param: "DtasheetUrl", name: this.lang.table_main_dtasheetUrl, value: result.data.Main[0].DtasheetUrl },
                        { param: "Description", name: this.lang.table_main_description, value: result.data.Main[0].Description },
                        { param: "ImageUrl", name: this.lang.table_main_imageUrl, value: result.data.Main[0].ImageUrl },
                        { param: "ProductDetailUrl", name: this.lang.table_main_productDetailUrl, value: result.data.Main[0].ProductDetailUrl },

                        { param: "LifecycleStatus", name: this.lang.table_main_lifecycleStatus, value: result.data.Main[0].LifecycleStatus },

                        // { param: "EOL", name: this.lang.table_main_EOL, value: result.data.Main[0].EOL },
                        // { param: "EOS", name: this.lang.table_main_EOS, value: result.data.Main[0].EOS },
                        // { param: "TempMin", name: this.lang.table_main_TempMin, value: result.data.Main[0].TempMin },
                        // { param: "TempMax", name: this.lang.table_main_TempMax, value: result.data.Main[0].TempMax },
                    ]

                    vue.properties = [];
                    for (let i = 0, lei = result.data.Properties.length; i < lei; i++){
                        let obj = {
                            name: result.data.Properties[i].Name,
                            value: result.data.Properties[i].Values,
                        }
                        vue.properties.push(obj);
                    }
                    vue.prices = [];
                    for (let i = 0, lei = result.data.Prices.length; i < lei; i++) {
                        let obj = {
                            currency: result.data.Prices[i].Currency,
                            price: result.data.Prices[i].Price,
                            minQuantity: result.data.Prices[i].MinQuantity
                        }
                        vue.prices.push(obj);
                    }
                    if (result.data.AdditionalData.length > 0){
                      vue.additional = [
                        { param: "EOL", name: "EOL", value: result.data.AdditionalData[0].EOL },
                        { param: "EOS", name: "EOS", value: result.data.AdditionalData[0].EOS },
                        { param: "Comment", name: "Comment", value: result.data.AdditionalData[0].Comment },

                        { param: "OverallRisk", name: "OverallRisk", value: result.data.AdditionalData[0].OverallRisk },
                        { param: "LifeCycleRiskGrade", name: "LifeCycleRiskGrade", value: result.data.AdditionalData[0].LifeCycleRiskGrade },
                        { param: "RohsRisk", name: "RohsRisk", value: result.data.AdditionalData[0].RohsRisk },
                        { param: "RoHSVersion", name: "RoHSVersion", value: result.data.AdditionalData[0].RoHSVersion },
                        { param: "ChinaRoHSStatus", name: "ChinaRoHSStatus", value: result.data.AdditionalData[0].ChinaRoHSStatus },
                        { param: "LifecycleRisk", name: "LifecycleRisk", value: result.data.AdditionalData[0].LifecycleRisk },
                        { param: "PartStatus", name: "PartStatus", value: result.data.AdditionalData[0].PartStatus },
                        { param: "EstimatedYearsToEOL", name: "EstimatedYearsToEOL", value: result.data.AdditionalData[0].EstimatedYearsToEOL },
                        { param: "MultiSourcingRisk", name: "MultiSourcingRisk", value: result.data.AdditionalData[0].MultiSourcingRisk },

                      ]

                    }else{
                      vue.additional = [
                        { param: "EOL", name: "EOL", value: "" },
                        { param: "EOS", name: "EOS", value: "" },
                        { param: "Comment", name: "Comment", value: "" },

                        { param: "OverallRisk", name: "OverallRisk", value: "" },
                        { param: "LifeCycleRiskGrade", name: "LifeCycleRiskGrade", value: "" },
                        { param: "RohsRisk", name: "RohsRisk", value: "" },
                        { param: "RoHSVersion", name: "RoHSVersion", value: "" },
                        { param: "ChinaRoHSStatus", name: "ChinaRoHSStatus", value: "" },
                        { param: "LifecycleRisk", name: "LifecycleRisk", value: "" },
                        { param: "PartStatus", name: "PartStatus", value: "" },
                        { param: "EstimatedYearsToEOL", name: "EstimatedYearsToEOL", value: "" },
                        { param: "MultiSourcingRisk", name: "MultiSourcingRisk", value: "" },
                      ]
                    }


                    this.buildMainTable();
                    this.buildPropertiesTable();
                    this.buildPricesTable();
                    this.buildAdditionalTable();
                })



        }
        this.getDataForForm();




  },
  methods: {
    getDataForForm() {

    },
    buildMainTable(){

        let main = this.main;



        var tableplace = document.getElementById(this.id_main_table);

        while (tableplace.firstChild) {
            tableplace.removeChild(tableplace.firstChild);
        }

        var table = document.createElement("table");
        table.setAttribute("id", "t_" + this.id_main_table);
        table.setAttribute("class", "table table-striped table-bordered");
        table.setAttribute("style", "width:100%;");
        tableplace.appendChild(table)



        var thead = document.createElement("thead");
        table.appendChild(thead);
        var tr = document.createElement("tr");


        thead.appendChild(tr);

        let vue = this;


        let cols =  [
            { "data": "name" },
            { "data": "value" },


        ]

        let columns = [

            {
            name: this.lang.main_table_header_Name,
            alignInColumn: "left",

            },
            {
            name: this.lang.main_table_header_Value,
            alignInColumn: "left",

            },



        ]




        var columnDefs = [];

        for (var i = 0, len = columns.length; i < len; i++){

            let classname = '_dt-body-'+ columns[i].alignInColumn;

            let  el = {
                targets: i,
                className: classname,
                render: function (data, type, row, meta) {
                    if (data == null) {
                        data = "";
                    }

                    data = $.fn.dataTable.render.text().display(data);
                    if (data.display != undefined) {
                        data.display = $.fn.dataTable.render.text().display(data.display);
                    }

                    if (meta.col == 0) {


                        return data;
                    }

                    if (meta.col == 1) {

                        let str = "";
                        str += "<div role=\"group\" class=\"input-group input-group-sm\">";
                        let disabled = "";
                        if (vue.source == "update") {
                            if (row.param == "ManufacturerName" || row.param == "ManufacturerPN") {
                                disabled = "disabled";
                            }
                        }

                        if (row.param == "EOL" || row.param == "EOS") {
                            str += "<input data-type=\"" + row.param + "\" class=\"form-control new-part-main\" type=\"date\" id=\"value__" + row.param + "\" value=\"" + data + "\" data-date-format=\"DD MMMM YYYY\">";

                        } else {

                            str += "<input "+disabled+" data-type=\"" + row.param + "\" class=\"form-control new-part-main\" type=\"text\" id=\"value__" + row.param + "\" value=\"" + data + "\">";

                        }
                        str += "</div>";

                        return str;


                    }
                }
            }

            columnDefs.push(el);


            var th = document.createElement("th");


            var br = document.createElement("br");
            th.appendChild(br);

            var tx = document.createTextNode(columns[i].name);
            th.appendChild(tx);


            tr.appendChild(th);


        }



        var json = {};
        json.paging = false;
        json.info = false;
        json.dom = '<t>';
        json.data = main;
        json.myColumnFormats = columns;
        json.select = false;
        json.columns = cols;
        json.columnDefs = columnDefs;
        json.ordering = false;
        json.order = [1, "asc"];


        if ($.fn.dataTable.isDataTable("#t_"+this.id_main_table)) {
            this.mainTable.destroy();

        }




        this.mainTable = $('#t_'+this.id_main_table).DataTable(json);


        this.$parent.$parent.$parent.$parent.$parent.$parent.mainTable = this.mainTable;

        //hide first column in table
        //this.mainTable.column( 0 ).visible( false );
        //this.mainTable.column( 1 ).visible( false );

        //search input change view
        // var searchplace = document.getElementById("t_" + this.id_main_table + "_filter").firstChild

        // while (searchplace.firstChild) {

        //     if (searchplace.firstChild.textContent == "Search:"){
        //         searchplace.removeChild(searchplace.firstChild);
        //         break;
        //     }

        // }

        // searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
        // searchplace.firstChild.setAttribute("class", "form-control form-control-sm")






    },
    buildPropertiesTable(){


        let properties = this.properties;



        var tableplace = document.getElementById(this.id_properties_table);

        while (tableplace.firstChild) {
            tableplace.removeChild(tableplace.firstChild);
        }

        var table = document.createElement("table");
        table.setAttribute("id", "t_" + this.id_properties_table);
        table.setAttribute("class", "table table-striped table-bordered");
        table.setAttribute("style", "width:100%;");
        tableplace.appendChild(table)



        var thead = document.createElement("thead");
        table.appendChild(thead);
        var tr = document.createElement("tr");


        thead.appendChild(tr);

        let vue = this;


        let cols =  [
            { "data": "name" },
            { "data": "value" },
            { "data": "value" },


        ]

        let columns = [

            {
            name: this.lang.properties_table_header_Name,
            alignInColumn: "left",

            },
            {
            name: this.lang.properties_table_header_Value,
            alignInColumn: "left",

            },
            {
            name: this.lang.properties_table_header_Action,
            alignInColumn: "left",

            },



        ]




        var columnDefs = [];

        for (var i = 0, len = columns.length; i < len; i++){

            let classname = '_dt-body-'+ columns[i].alignInColumn;

            let  el = {
                targets: i,
                className: classname,
                render: function ( data, type, row, meta ) {
                    if (data == null) {
                        data = "";
                    }

                    data = $.fn.dataTable.render.text().display(data);
                    if (data.display != undefined) {
                        data.display = $.fn.dataTable.render.text().display(data.display);
                    }

                if (meta.col == 0){
                    if (data == undefined) {
                        data = "";
                    }

                    let str = "";
                    str += "<div role=\"group\" class=\"input-group input-group-sm\">";
                    str += "<input data-type=\"name\" class=\"form-control new-part-props-name\" type=\"text\" id=\"name__" + meta.row + "\" value=\"" + data +"\">";
                    str += "</div>";
                    return str;
                }

                if (meta.col == 1){
                    if (data == undefined) {
                        data = "";
                    }
                    let str = "";
                    str += "<div role=\"group\" class=\"input-group input-group-sm\">";
                    str += "<input data-type=\"value\" class=\"form-control new-part-props-value\" type=\"text\" id=\"value__" + meta.row + "\" value=\"" + data +"\">";
                    str += "</div>";
                    return str;


                }
                if (meta.col == 2){

                    let str = "<button class=\"btn btn-secondary btn-sm btn-" + vue.variant + " button_props_delete\" id=\"button_remove_" + meta.row +"\" >"+ vue.lang.properties_table_button_Delete+"</button>";

                    return  str;
                }

                return data;
                }
            }

            columnDefs.push(el);

            let wd = { width: 70, targets: 2 };
            columnDefs.push(wd);

            var th = document.createElement("th");

            var br = document.createElement("br");
            th.appendChild(br);

            var tx = document.createTextNode(columns[i].name);
            th.appendChild(tx);


            tr.appendChild(th);


        }

        let counter = 0;

        const buttons = [
            {
                text: 'Add',
                className: 'addButton btn-' + vue.variant,
                action: function ( e, dt, node, config ) {
                    vue.propertiesTable.row.add( [

                        counter
                    ] ).draw( false );

                    function handler(e){


                        vue.propertiesTable
                        .row( $(this).parents('tr') )
                        .remove()
                        .draw();
                    }

                    let buttons_action_delete = document.getElementsByClassName('button_props_delete');

                    if (buttons_action_delete.removeEventListener) {

                    }
                    for (var i = 0; i < buttons_action_delete.length; i++) {
                        buttons_action_delete[i].removeEventListener("click", handler)
                    }
                    for (var i = 0; i < buttons_action_delete.length; i++) {
                        buttons_action_delete[i].addEventListener('click', handler)

                    }


                    counter++;
                }
            }
        ]

        var json = {};
        json.paging = false;
        json.info = false;
        json.dom = 'B<t>';
        json.data = vue.properties;
        json.myColumnFormats = columns;
        json.select = false;
        json.ordering = false;
        json.columns = cols;
        json.columnDefs = columnDefs;
        json.order = [1, "asc"];
        json.buttons = buttons;


        if ($.fn.dataTable.isDataTable("#t_"+this.id_properties_table)) {
            this.propertiesTable.destroy();

        }

        this.propertiesTable = $('#t_'+this.id_properties_table).DataTable(json);

    },
    buildPricesTable(){


        const prices = this.prices;



        var tableplace = document.getElementById(this.id_prices_table);

        while (tableplace.firstChild) {
            tableplace.removeChild(tableplace.firstChild);
        }

        var table = document.createElement("table");
        table.setAttribute("id", "t_" + this.id_prices_table);
        table.setAttribute("class", "table table-striped table-bordered");
        table.setAttribute("style", "width:100%;");
        tableplace.appendChild(table)



        var thead = document.createElement("thead");
        table.appendChild(thead);
        var tr = document.createElement("tr");


        thead.appendChild(tr);

        let vue = this;


        let cols =  [
            { "data": "minQuantity" },
            { "data": "price" },
            { "data": "currency" },
            { "data": "currency" },

        ]

        let columns = [

            {
            name: this.lang.price_table_header_MinQuantity,
            alignInColumn: "left",

            },
            {
            name: this.lang.price_table_header_Price,
            alignInColumn: "left",

            },
            {
            name: this.lang.price_table_header_Currency,
            alignInColumn: "left",

            },
            {
            name: this.lang.price_table_header_Action,
            alignInColumn: "left",

            },



        ]




        var columnDefs = [];

        for (var i = 0, len = columns.length; i < len; i++){

            let classname = '_dt-body-'+ columns[i].alignInColumn;

            let  el = {
                targets: i,
                className: classname,
                render: function ( data, type, row, meta ) {
                    if (data == null) {
                        data = "";
                    }

                    data = $.fn.dataTable.render.text().display(data);
                    if (data.display != undefined) {
                        data.display = $.fn.dataTable.render.text().display(data.display);
                    }

                if (meta.col == 0){
                    if (data == undefined) {
                        data = "";
                    }

                    let str = "";
                    str += "<div role=\"group\" class=\"input-group input-group-sm\">";
                    str += "<input data-type=\"minQuantity\" class=\"form-control new-part-price-quantity\" type=\"text\" id=\"name__" + meta.row + "\" value=\"" + data +"\">";
                    str += "</div>";
                    return str;
                }

                if (meta.col == 1){
                    if (data == undefined) {
                        data = "";
                    }
                    let str = "";
                    str += "<div role=\"group\" class=\"input-group input-group-sm\">";
                    str += "<input data-type=\"price\" class=\"form-control new-part-price-price\" type=\"text\" id=\"value__" + meta.row + "\" value=\"" + data +"\">";
                    str += "</div>";
                    return str;


                }
                if (meta.col == 2){

                    let str = "";
                    str += "<div role=\"group\" class=\"input-group input-group-sm\">";
                    str += "<select data-type=\"currency\" class=\"form-control new-part-price-currency\" type=\"text\" id=\"currency__" + meta.row + "\" value=\"" + data + "\">";


                    for (let i = 0, lei = vue.currencyTable.length; i < lei; i++){
                        let selected = "";
                        if (vue.currencyTable[i] == data) {
                            selected = "selected=\"selected\"";
                        }
                        str += "<option " + selected + "value=\"" + vue.currencyTable[i] + "\">" + vue.currencyTable[i] + "</option>";
                    }

                    str += "</select>";
                    str += "</div>";
                    return str;


                }
                if (meta.col == 3){

                    let str = "<button class=\"btn btn-secondary btn-sm btn-" + vue.variant + " button_price_delete  action\" id=\"button_remove_" + meta.row +"\" >"+ vue.lang.price_table_button_Delete+"</button>";

                    return  str;
                }

                return data;
                }
            }

            columnDefs.push(el);

            let wd = { width: 70, targets: 3 };
            columnDefs.push(wd);


            var th = document.createElement("th");


            var br = document.createElement("br");
            th.appendChild(br);

            var tx = document.createTextNode(columns[i].name);
            th.appendChild(tx);


            tr.appendChild(th);


        }

        let counter = 0;

        const buttons = [
            {
                text: 'Add',
                className: 'addButton btn-' + vue.variant,
                action: function ( e, dt, node, config ) {
                    vue.priceTable.row.add( [

                        counter
                    ] ).draw( false );

                    function handler(e){


                        vue.priceTable
                        .row( $(this).parents('tr') )
                        .remove()
                        .draw();
                    }

                    let buttons_action_delete = document.getElementsByClassName('button_price_delete');

                    if (buttons_action_delete.removeEventListener) {

                    }
                    for (var i = 0; i < buttons_action_delete.length; i++) {
                        buttons_action_delete[i].removeEventListener("click", handler)
                    }
                    for (var i = 0; i < buttons_action_delete.length; i++) {
                        buttons_action_delete[i].addEventListener('click', handler)

                    }


                    counter++;
                }
            }
        ]

        var json = {};
        json.paging = false;
        json.info = false;
        json.dom = 'B<t>';
        json.data = vue.prices;
        json.myColumnFormats = columns;
        json.select = false;
        json.columns = cols;
        json.ordering = false;
        json.columnDefs = columnDefs;
        json.order = [1, "asc"];
        json.buttons = buttons;


        if ($.fn.dataTable.isDataTable("#t_"+this.id_prices_table)) {
            this.priceTable.destroy();

        }

        this.priceTable = $('#t_'+this.id_prices_table).DataTable(json);

    },
    buildAdditionalTable(){

        let additional = this.additional;

        let vue = this;

        var tableplace = document.getElementById(this.id_additional_table);

        while (tableplace.firstChild) {
            tableplace.removeChild(tableplace.firstChild);
        }

        var table = document.createElement("table");
        table.setAttribute("id", "t_" + this.id_additional_table);
        table.setAttribute("class", "table table-striped table-bordered");
        table.setAttribute("style", "width:100%;");
        tableplace.appendChild(table)



        var thead = document.createElement("thead");
        table.appendChild(thead);
        var tr = document.createElement("tr");


        thead.appendChild(tr);



        let cols =  [
            { "data": "name" },
            { "data": "value" },


        ]

        let columns = [

            {
            name: this.lang.main_table_header_Name,
            alignInColumn: "left",

            },
            {
            name: this.lang.main_table_header_Value,
            alignInColumn: "left",

            },



        ]




        var columnDefs = [];

        for (var i = 0, len = columns.length; i < len; i++){

            let classname = '_dt-body-'+ columns[i].alignInColumn;

            let  el = {
                targets: i,
                className: classname,
                render: function (data, type, row, meta) {
                    if (data == null) {
                        data = "";
                    }

                    data = $.fn.dataTable.render.text().display(data);
                    if (data.display != undefined) {
                        data.display = $.fn.dataTable.render.text().display(data.display);
                    }

                    if (meta.col == 0) {


                        return data;
                    }

                    if (meta.col == 1) {

                        let str = "";
                        str += "<div role=\"group\" class=\"input-group input-group-sm\">";


                        if (row.param == "EOL" || row.param == "EOS") {

                          const value = data.split('T')[0];

                          str += "<input data-type=\"" + row.param + "\" class=\"form-control new-part-additional\" type=\"date\" id=\"value__" + row.param + "\" value=\"" + value + "\" data-date-format=\"DD MMMM YYYY\">";

                        } else if (row.param == "OverallRisk" || row.param == "LifecycleRisk" || row.param == "MultiSourcingRisk" || row.param == "LifeCycleRiskGrade" || row.param == "RohsRisk") {

                            str += "<select  class=\"form-control new-part-additional\" data-type=\"" + row.param + "\">";
                            for (let j = 0, lej = vue.optionType.length; j < lej; j++) {

                                let selected = "";

                                if (vue.optionType[j].value == row.value){
                                    selected = "selected=\"selected\"";
                                }

                                str += "<option "+ selected + "value=\"" + vue.optionType[j].value + "\">" + vue.optionType[j].text + "</option>";

                            }
                            str += "</select>";

                        } else if (row.param == "Comment") {

                            str += "<textarea type=\"text\"  data-type=\"" + row.param + "\"  rows=\"6\" wrap=\"soft\" class=\"form-control new-part-additional textarea-field\"  value=\"" + data + "\">"+data+"</textarea>";

                        } else {

                            str += "<input data-type=\"" + row.param + "\" class=\"form-control new-part-additional\" type=\"text\" id=\"value__" + row.param + "\" value=\"" + data + "\">";

                        }
                        str += "</div>";

                        return str;


                    }
                }
            }

            columnDefs.push(el);


            var th = document.createElement("th");


            var br = document.createElement("br");
            th.appendChild(br);

            var tx = document.createTextNode(columns[i].name);
            th.appendChild(tx);


            tr.appendChild(th);


        }



        var json = {};
        json.paging = false;
        json.info = false;
        json.dom = '<t>';
        json.data = additional;
        json.myColumnFormats = columns;
        json.select = false;
        json.columns = cols;
        json.columnDefs = columnDefs;
        json.ordering = false;
        json.order = [1, "asc"];


        if ($.fn.dataTable.isDataTable("#t_"+this.id_additional_table)) {
            this.additionalTable.destroy();

        }




        this.additionalTable = $('#t_'+this.id_additional_table).DataTable(json);



        //hide first column in table
        //this.mainTable.column( 0 ).visible( false );
        //this.mainTable.column( 1 ).visible( false );



    },
  }
}
</script>


<style lang="scss">
@import "./../../scss/_custom.scss";
    .FormPhysicalComponent{
        table{

            padding: 0px !important;

        }
        table th {
            padding: 0rem !important;

            padding-left: 0.2rem !important;
            padding-right: 0.2rem !important;

        }
        table.dataTable thead th {
            position: relative;
            background-image: none !important;
        }
        table td {
            padding: 0.2rem !important;

        }

        .dataTables_filter{
            font-size: 10px;
            float: left;
            width: 210px;
        }
        .searcher{
            float: left;
        }
        .dt-buttons{

            font-size: 0.7rem;
            //margin-left: 210px;

        }
        .dataTables_filter .form-control-sm, .input-group-sm > .form-control{
            padding: 0.1rem 0.1rem;
            font-size: 0.7rem;
            line-height: 1;
            //width: 200px;
        }
        .btn{
            padding-top: 1px;
            padding-bottom: 1px;
            padding-left: 3px;
            padding-right: 3px;

            font-size: 0.7rem;

        }
        .btn-group{
            display: block;
            padding-top: 2px;
        }
        ._dt-body-left{
            text-align: left;
        }
        ._dt-body-right{
            text-align: right;
        }
        ._dt-body-center{
            text-align: center;
        }

        td{
        word-break: break-all;
        }
        .addButton{
            margin: 5px;
        }
        .textarea-field{
            height: 70px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/shared/FormPhysicalComponent.vue